import { useBreakpointValue } from '@genial/utils';

import { DividendHistoryItemLoadingDesktop } from './Desktop';
import { DividendHistoryItemLoadingMobile } from './Mobile';
import { DividendHistoryItemLoadingTablet } from './Tablet';

export const DividendHistoryItemLoading = () => {
  return useBreakpointValue({
    base: <DividendHistoryItemLoadingMobile />,
    sm: <DividendHistoryItemLoadingTablet />,
    lg: <DividendHistoryItemLoadingDesktop />,
  });
};
